import React from 'react'
import { useTimer } from 'react-timer-hook'
import { Box, useTheme } from '@mui/material'
import Timer from '../../../../assets/icons/Timer.svg'

interface Props {
    expiryTimestamp?: Date
    onFinishExam: () => void
}
const ExamTimer: React.FC<Props> = ({ expiryTimestamp, onFinishExam }) => {
    const theme = useTheme()
    const { seconds, minutes, hours, days, isRunning, start } = useTimer({
        expiryTimestamp: expiryTimestamp,
        onExpire: () => onFinishExam(),
    })

    const styles = {
        wrapper: {
            borderRadius: '8px',
            border: `1px solid ${theme.palette.grey[200]}`,
            mb: 2,
            p: 2,

            '@media screen and (max-width: 500px)': {
                p: 0,
                border: 'none',
            },
        },
        title: {
            mb: 2,
            fontWeight: 500,
            '@media screen and (max-width: 500px)': {
                display: 'none',
            },
        },
        time: {
            display: 'flex',
            alignItems: 'center',
            background: theme.palette.grey[100],
            padding: '8px',
            borderRadius: '6px',
        },
    }

    return (
        <Box sx={styles.wrapper}>
            <Box sx={styles.title}>Оставшееся время:</Box>

            <Box sx={styles.time}>
                <img
                    src={Timer}
                    alt="timer"
                />

                <Box sx={{ ml: 1 }}>
                    <span>{days}</span>:<span>{hours}</span>:
                    <span>{minutes}</span>:<span>{seconds}</span>
                </Box>
            </Box>
        </Box>
    )
}

export default ExamTimer
